import { useTranslation } from "react-i18next";
import { useMemo } from "react";

export const useConnectivityKeyMapping = () => {
  const { t } = useTranslation();
  return useMemo(() => {
    return {
      vendor: t("CHARGE_POINT_VENDOR"),
      model: t("CHARGE_POINT_MODEL"),
      chargePointSerialNumber: t("CHARGE_POINT_SERIAL_NUMBER"),
      chargeBoxSerialNumber: t("CHARGE_BOX_SERIAL_NUMBER"),
      firmwareVersion: t("FIRMWARE_VERSION"),
      connectionType: t("CONNECTION_TYPE")
    };
  }, [t]);
};
